import { useTranslation } from 'react-i18next';
import type { Option } from '#pie/components/input-radio/InputRadio';
import type { CreateDataRequestDto } from '#pie/internal/api/pie-bff';
import { ReasonForDataRequest } from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormRadio, FormText } =
  typedFormFields<CreateDataRequestDto>();

export const Reason = () => {
  // Met welk doel wil je data aanvragen?
  const { t } = useTranslation('dataRequest');

  const options: Option[] = [
    {
      label: t(`reason_for_data_request.${ReasonForDataRequest.EnergySaving}`),
      value: ReasonForDataRequest.EnergySaving,
    },
    {
      label: t(`reason_for_data_request.${ReasonForDataRequest.Monitoring}`),
      value: ReasonForDataRequest.Monitoring,
    },
    {
      label: t(`reason_for_data_request.${ReasonForDataRequest.Planning}`),
      value: ReasonForDataRequest.Planning,
    },
    {
      label: t(`reason_for_data_request.${ReasonForDataRequest.Research}`),
      value: ReasonForDataRequest.Research,
    },
    {
      label: t(
        `reason_for_data_request.${ReasonForDataRequest.LegalObligation}`,
      ),
      value: ReasonForDataRequest.LegalObligation,
    },
    {
      label: t(
        `reason_for_data_request.${ReasonForDataRequest.OptimiseBulkUse}`,
      ),
      value: ReasonForDataRequest.OptimiseBulkUse,
    },
    {
      label: t(`reason_for_data_request.${ReasonForDataRequest.Other}`),
      renderInput: (
        <ConditionalField
          field="reasonNote"
          condition={(fieldValue) => {
            return fieldValue('reason') === ReasonForDataRequest.Other;
          }}
        >
          <FormText
            aria-label={t('other_note')}
            fullWidth
            name="reasonNote"
            showWordCount
            rules={{ maxLength: 30, minLength: 5, required: true }}
          />
        </ConditionalField>
      ),
      value: ReasonForDataRequest.Other,
    },
  ];

  return (
    <FormRadio
      label={t('reason')}
      options={options}
      name="reason"
      rules={{ required: true }}
    />
  );
};
